import { useEffect, useState } from "react";
import Icon from "@mdi/react";
import { xor } from "lodash";
import Modal from "react-responsive-modal";
import { useTitle } from "easy-page-router/react";
import { mdiAccountEdit, mdiAccountTie, mdiPen, mdiPlus } from "@mdi/js";
import { useHeaders } from "../../ssrh/client";

import { useUser } from "../User";
import { api, useApi } from "../services/api";
import { Header, Remove, Separator } from "../components";
import Footer from "../components/Footer";

import { _ID, User } from "../../types";

export default function Mayors() {
    const { user, isAdmin, isMayor, setUser } = useUser();

    useTitle("Starosta | TSO Krkonoše");
    useHeaders({
        title: "Starosta | Administrace | TSO Krkonoše",
        description: "Admnistrace pro technický svazek obcí Krkonoše",
        image: window.location.origin + "/logo.png",
        canonical: window.location.origin + window.location.pathname,
    });

    const [mail, setMail] = useState("");
    const [password, setPassword] = useState("");

    const [message, setMessage] = useState("");

    return (
        <>
            <main>
                <Header
                    background="stars"
                    title={user === null ? "Přihlášení" : isAdmin ? "Administrace" : "Starosta"}
                />
                <div className="content">
                    <section>
                        <div className="page">
                            {user === null && (
                                <>
                                    <h1>Přihlášení</h1>
                                    <Separator />
                                    <form
                                        onSubmit={async (e) => {
                                            e.preventDefault();

                                            if (!password) {
                                                setMessage("Heslo je prázdné");
                                                return;
                                            }

                                            if (!mail) {
                                                setMessage("E-mail je prázdný");
                                                return;
                                            }

                                            if (password.length < 6) {
                                                setMessage("Heslo je příliš krátké");
                                                return;
                                            }

                                            if (!mail.includes("@")) {
                                                setMessage("Zadaný e-mail je neplatný");
                                                return;
                                            }

                                            setMessage("Probíhá přihlašování...");
                                            const [user] = await api.addLogin({
                                                mail,
                                                password,
                                            });

                                            if (user) {
                                                console.log(user);
                                                setUser(user);
                                                setMessage(
                                                    "Přihlášení proběhlo úspěšně",
                                                );
                                            } else {
                                                setMessage("Přihlášení selhalo");
                                                return;
                                            }
                                        }}
                                    >
                                        <input
                                            type="email"
                                            placeholder="E-mail"
                                            value={mail}
                                            onChange={(e) => setMail(e.target.value)}
                                        />

                                        <input
                                            type="password"
                                            placeholder="Heslo"
                                            value={password}
                                            onChange={(e) =>
                                                setPassword(e.target.value)}
                                        />

                                        {message && <p className="alert">{message}</p>}

                                        <input
                                            type="submit"
                                            value="Přihlásit se"
                                            disabled={!mail || !password}
                                        />
                                    </form>
                                </>
                            )}

                            {user && (
                                <>
                                    <div className="user main">
                                        <Icon path={isAdmin ? mdiAccountEdit : mdiAccountTie} size={5} />
                                        <h2>{user.name}</h2>
                                        <p>{user.mail}</p>
                                        <p>
                                            {isAdmin && <b>Administrátor webu</b>}
                                            {isAdmin && isMayor && " a "}
                                            {isMayor && <b>Starosta</b>}
                                        </p>
                                    </div>


                                    {message && <p className="alert">{message}</p>}

                                    {!isAdmin && !isMayor && (
                                        <p className="alert">Nemáš žádná práva 🙁</p>
                                    )}

                                    {isMayor && <>
                                        <h2>Starosta</h2>
                                        <p>Pro přístup k rezervačním systémům navštivte webovou stránku: <a href="https://jilemnicko-so.cz/starosta" target="_blank">jilemnicko-so.cz/starosta</a>.</p>
                                        <div style={{ height: "100px" }} />
                                    </>}

                                    {isAdmin && <Administration />}
                                </>
                            )}
                        </div>
                    </section>
                </div>
            </main>
            <Footer />
        </>
    );
}

function Administration() {
    // const { user, setUser } = useUser();
    const [users, error, loading, , reload] = useApi.getUsers({});

    const [editUser, setEditUser] = useState<null | Omit<User, "password"> & _ID>(null);

    function handleNewUser() {
        setEditUser({
            _id: "",
            name: "",
            mail: "",
            roles: [],
        });
    }

    async function handleSave(user: User & _ID): Promise<string> {
        if (user.name.length < 4) return "Jméno je příliš krátké";
        if (!user.mail.includes("@")) return "E-mail je neplatný";

        if (user._id === "") {
            // new user
            if (user.password.length < 6) return "Heslo je příliš krátké";

            const [id] = await api.addUser(user);

            if (id) {
                reload();
                setEditUser(null);
                return "Uživatel přidán";
            } else {
                return "Přidání uživatele selhalo";
            }
        } else {
            const [, error] = await api.updateUser(user);

            if (error) {
                return "Upravit uživatele selhalo";
            } else {
                reload();
                return "Uživatel upraven";
            }
        }
    }

    async function handleRemove(userId: string) {
        const [, error] = await api.removeUser({ userId });

        if (error) {
            return "Smazání uživatele selhalo";
        } else {
            reload();
            setEditUser(null);
            return "Uživatel smazán";
        }
    }

    return (
        <>
            <h2>
                Administrace uživatelů
                <button style={{ marginLeft: "20px" }} className="ticket" onClick={handleNewUser}>
                    <Icon path={mdiPlus} size={1} /> Přidat uživatele
                </button>
            </h2>

            <EditUser
                user={editUser}
                onSave={handleSave}
                onRemove={handleRemove}
                onClose={() => setEditUser(null)}
            />

            {loading && <p className="alert">Načítání dat...</p>}
            {error && <p className="alert">{error}</p>}
            {users && (
                <div className="list slim">
                    {users.map((user) => (
                        <div key={user._id} className="item">
                            <div className="user grow">
                                <Icon path={user.roles.includes("admin") ? mdiAccountEdit : mdiAccountTie} size={5} />
                                <h2>{user.name}</h2>
                                <p>{user.mail}</p>
                                <p>
                                    {user.roles.includes("admin") && <b>Administrátor webu</b>}
                                    {user.roles.length > 1 && " a "}
                                    {user.roles.includes("mayor") && <b>Starosta</b>}
                                </p>
                            </div>
                            <div className="admin">
                                <button onClick={() => setEditUser(user)}>
                                    <Icon path={mdiPen} size={1} /> Udělat změny
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}

type EditUserProps = {
    user: null | (Omit<User, "password"> & _ID);
    onSave: (user: User & _ID) => Promise<string>;
    onRemove: (userId: string) => void;
    onClose: () => void;
};

function EditUser({ user, onSave, onRemove, onClose }: EditUserProps) {
    const [editUser, setEditUser] = useState(user);
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        setEditUser(user);
        setPassword("");
        setMessage("");
    }, [user]);

    const isNewUser = editUser?._id === "";

    async function handleNewPassword() {
        if (!editUser || editUser._id === "") return;

        if (password.length < 6) {
            setMessage("Heslo je příliš krátké");
            return;
        }

        setPassword("Ukládám nové heslo...");
        const [, error] = await api.updateUserPassword({
            userId: editUser._id,
            password,
        });

        if (error) {
            setMessage("Nastavení nového hesla selhalo");
        } else {
            setMessage("Nové heslo bylo nastaveno");
            setPassword("");
        }
    }

    return (
        <Modal
            open={user !== null}
            onClose={onClose}
            center
            styles={{
                modal: { width: "500px" },
            }}
        >
            <h2>{editUser?._id ? "Upravit" : "Přidat"} uživatele</h2>

            {message && <p className="alert">{message}</p>}

            {editUser && (
                <>
                    <input
                        type="text"
                        placeholder="Jméno"
                        value={editUser.name}
                        onChange={(e) =>
                            setEditUser({ ...editUser, name: e.target.value })}
                    />
                    <input
                        type="email"
                        placeholder="E-mail"
                        value={editUser.mail}
                        onChange={(e) =>
                            setEditUser({ ...editUser, mail: e.target.value })}
                    />

                    <label>Role uživatele</label>
                    <div>
                        <span
                            className={`ticket clickable ${editUser.roles.includes("admin") ? "" : "empty"
                                }`}
                            onClick={() => {
                                setEditUser({
                                    ...editUser,
                                    roles: xor(editUser.roles, ["admin"]),
                                });
                            }}
                        >
                            <Icon path={mdiAccountEdit} size={1} />{" "}
                            Administrátor webu
                        </span>
                        <span
                            className={`ticket clickable ${editUser.roles.includes("mayor") ? "" : "empty"
                                }`}
                            onClick={() => {
                                setEditUser({
                                    ...editUser,
                                    roles: xor(editUser.roles, ["mayor"]),
                                });
                            }}
                        >
                            <Icon path={mdiAccountTie} size={1} /> Starosta
                        </span>
                    </div>

                    {isNewUser && (
                        <input
                            type="text"
                            placeholder="Nové heslo"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    )}

                    {!isNewUser && (
                        <div className="flex right">
                            <button
                                onClick={async () => {
                                    setMessage("Ukládám...");
                                    setMessage(
                                        await onSave({ ...editUser, password }),
                                    );
                                }}
                            >
                                Uložit
                            </button>
                        </div>
                    )}

                    <div className="divider" />

                    {!isNewUser && <>
                        <h3 style={{ paddingTop: "32px" }}>Změnit heslo</h3>
                        <div className="flex">
                            <input
                                type="text"
                                placeholder="Nové heslo"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button onClick={handleNewPassword}>
                                Nastavit nové heslo
                            </button>
                        </div>
                    </>}
                    {!isNewUser && <div className="divider" />}

                    <div className="flex">
                        {!isNewUser && <Remove onRemove={() => onRemove(editUser._id)}>Smazat uživatele</Remove>}
                        {isNewUser && (
                            <button
                                onClick={async () => {
                                    setMessage("Ukládám...");
                                    setMessage(
                                        await onSave({ ...editUser, password }),
                                    );
                                }}
                            >
                                Přidat uživatele
                            </button>
                        )}
                        <button onClick={onClose}>Zavřít</button>
                    </div>
                </>
            )}
        </Modal>
    );
}
